<template>
    <VirtualScrollTable
        :columns="columns"
        :data="usersData"
        :columnHiddenOption="columnHiddenOption"
        class="course-table"
        :max-height="500"
    />
</template>

<script>
import VirtualScrollTable from 'components/user/organizationreport/tables/VirtualScrollTable'
import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'
import hideColumns from 'components/user/organizationreport/tables/helpers/hideColumns'
import moment from 'moment-timezone'

export default {
    name: 'course-table',
    components: {VirtualScrollTable},
    mixins: [convertMinutesToHours, hideColumns],
    props: {
        data: {
            type: Array
        }
    },
    data () {
        return {
            usersData: [],
            columnHiddenOption: {
                defaultHiddenColumnKeys: ['email'],
            },
            virtualScrollOption: {
                enable: true
            },
            columns: [
                {
                    field: 'name',
                    key: 'name',
                    title:  this.$t('ReportingTable.name'),
                    align: 'left',
                    sortBy: 'asc',
                    width: 300,
                    renderBodyCell: ({row, column, rowIndex}, h) => {
                        const name = row[column.field]
                        const email = row.email

                        let boldClasses = 'table-cell --bold'
                        let blockClasses = 'table-cell --block'

                        return (
                            <div>
                                <span class={boldClasses}>{name}</span>
                                <span class={blockClasses}>{email}</span>
                            </div>
                        )
                    }
                },
                { field: 'company', key: 'company', title: this.$t('ReportingTable.company'), align: 'left', sortBy: '', width: 250 },
                { field: 'department', key: 'department', title: this.$t('ReportingTable.department'), align: 'left', sortBy: '', width: 250 },
                { field: 'team', key: 'team', title: this.$t('ReportingTable.team'), align: 'left', sortBy: '', width: 250 },
                {
                    field: 'progress',
                    key: 'progress',
                    title: this.$t('ReportingTable.progress'),
                    align: 'left',
                    sortBy: '',
                    width: 200,
                    renderBodyCell: ({row, column, rowIndex}, h) => {
                        const progress = row[column.field]

                        if (progress === 100) {
                            return <span class="table-cell --bold">{progress} %</span>
                        }
                        return <span>{progress} %</span>
                    }
                },
                {
                    field: 'startedAt',
                    key: 'startedAt',
                    title: this.$t('ReportingTable.started'),
                    align: 'left',
                    sortBy: '',
                    width: 200,
                    renderBodyCell: ({row, column, rowIndex}, h) => {
                        const startedAt = row[column.field]
                        return moment(startedAt).format('DD.MM.YYYY')
                    }
                },
                {
                    field: 'completedAt',
                    key: 'completedAt',
                    title: this.$t('ReportingTable.completed'),
                    align: 'left',
                    sortBy: '',
                    renderBodyCell: ({row, column, rowIndex}, h) => {
                        const completedAt = row[column.field]
                        if (completedAt !== null) {
                            return moment(completedAt).format('DD.MM.YYYY')
                        }
                    }
                },
            ]
        }
    },
    methods: {
        modifyData () {
            const users = this.data.map(course => {
                return {
                    ...course,
                    rowKey: course.id
                }
            })
            this.usersData = users
        }
    },
    watch: {
        data: {
            handler: 'modifyData'
        }
    }
}
</script>

<style lang="scss">
.course-table {
    .table-cell {
        color: $black;

        &.--bold {
            font-family: Nunito-ExtraBold, sans-serif;
        }

        &.--block {
            display: block;
            color: $emperor;
        }

        &.--expired {
            color: $gray;
        }
    }
}
</style>
